import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfigService } from '../../services/config.service';
import { MapService } from '../services/map.service';

import { LocateUnit } from '../../models/map.interface';

@Injectable({
	providedIn: 'root'
})
export class LocateService {

	locateControls: any[] = [];

	constructor(
		private http: HttpClient,
		private configService: ConfigService,
		private mapService: MapService
	) { }

	/**
	 * Returns an array of location options, eg:
	 * 	"locate": [
	 *	  {
	 *		"name": "Manual Entry",
	 *		"type": "ces"
	 *	  }
	 *   ]
	 */
	getLocateUnit(): any[] {
		let locateUnit = null;

		if (this.configService.getConfig()?.esri?.locate) {
			locateUnit = this.configService.getConfig().esri.locate;
			for (let i = 0; i < locateUnit.length; i++) {
				let locate = locateUnit[i];
				switch (locate.type) {
					case "geometryList":
						this.processGeometryList(locate);
						break;
					case "township/rancho":
						this.processTownshipAndRange(locate);
						this.processRancho(locate);
						break;
					case "dynamic":
						this.processDynamicLocate(locate);
						break;
					case "measureToGeometry":
						this.processMeasureToGeometry(locate);
						break;
					default:
						break;
				}
			}
		}

		return locateUnit;
	}

	private processGeometryList(locate: LocateUnit): any { }

	private processTownshipAndRange(locate: LocateUnit): any {
		//		esriLoader.loadModules(["esri/tasks/QueryTask", "esri/tasks/query"], srsApp.CONFIG.version.arcgisVersion).then(
		//		               function ([QueryTask, Query]) {
		//		                   queryTask = new esri.tasks.QueryTask(locate.url);
		//		                   query = new esri.tasks.Query();
		//		                   query.returnGeometry = true;
		//		                   query.outFields = [locate.townshipField, locate.rangeField];
		//		                   query.where = "objectid > -1";
		//		                   query.returnDistinctValues = true;
		//		                   query.returnGeometry = false;
		//		                   queryTask.execute(query, function (result) {
		//		                       var townTrack = {};
		//		                       for (var i = 0; i < result.features.length; i++) {
		//		                           var currFeature = result.features[i];
		//		                           var township = currFeature.attributes[locate.townshipField];
		//		                           var range = currFeature.attributes[locate.rangeField];
		//
		//		                           if (township.trim() == "")
		//		                               continue;
		//
		//		                           if (townTrack[township]) {
		//		                               if (!townTrack[township][range])
		//		                                   townTrack[township][range] = 1;
		//
		//		                           } else {
		//		                               firstRange = {};
		//		                               firstRange[range] = 1;
		//		                               townTrack[township] = firstRange;
		//		                           }
		//		                       }
		//
		//		                       var townies = [];
		//		                       for (var township in townTrack) {
		//		                           var currTown = {
		//		                               name: township,
		//		                               ranges: []
		//		                           };
		//		                           var ranges = [];
		//		                           for (var range in townTrack[township]) {
		//		                               ranges.push({
		//		                                   name: range,
		//		                                   sections: []
		//		                               });
		//		                           }
		//		                           currTown.ranges = ranges.sort(function (a, b) {
		//		                               return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)
		//		                           });
		//		                           townies.push(currTown)
		//		                       };
		//
		//		                       locate.townships = townies.sort(function (a, b) {
		//		                           return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)
		//		                       });
		//		                   }, function (error) {
		//		                       locate.valid = false;
		//		                   });
		//		               });
	}

	private processRancho(locate: LocateUnit): any {
		//		esriLoader.loadModules([
		//						"esri/tasks/QueryTask", 
		//						"esri/tasks/query", 
		//						"esri/geometry/SpatialReference"
		//					], srsApp.CONFIG.version.arcgisVersion).then(function ([
		//						QueryTask, 
		//						Query, 
		//						SpatialReference
		//					]) {
		//		                   queryTask = new esri.tasks.QueryTask(locate.url);
		//		                   query = new esri.tasks.Query();
		//		                   query.outFields = [locate.ranchoField];
		//		                   query.where = "objectid > -1 AND " + locate.ranchoField + " NOT LIKE \' \'";
		//		                   query.returnGeometry = true;
		//		                   query.outSpatialReference = new SpatialReference(configService.getConfig().esri.spatialReference);
		//		                   queryTask.execute(query, function (result) {
		//		                       var ranchos = [];
		//		                       var ranchoTrack = {};
		//		                       for (var i = 0; i < result.features.length; i++) {
		//		                           var currentFeature = result.features[i];
		//		                           var rancho = currentFeature.attributes[locate.ranchoField];
		//		                           if (rancho && rancho.trim() != "") {
		//		                               if (!ranchoTrack[rancho]) {
		//		                                   ranchoTrack[rancho] = 1;
		//
		//		                                   ranchos.push({
		//		                                       name: rancho,
		//		                                       geometry: currentFeature.geometry
		//		                                   });
		//		                               } else {
		//		                                   ranchos.push({
		//		                                       name: rancho + " " + ++ranchoTrack[rancho],
		//		                                       geometry: currentFeature.geometry
		//		                                   });
		//		                               }
		//		                           }
		//		                       }
		//		                       locate.rancho = ranchos.sort(function (a, b) {
		//		                           return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0);
		//		                       });
		//		                   }, function (error) {
		//		                       locate.valid = false;
		//		                   });
		//		               });
	}
	private processDynamicLocate(locate: LocateUnit): any {
		//		esriLoader.loadModules(["esri/tasks/QueryTask", "esri/tasks/query"], srsApp.CONFIG.version.arcgisVersion).then(
		//	                function ([QueryTask, Query]) {
		//	                    queryTask = new esri.tasks.QueryTask(locate.url);
		//	                    query = new esri.tasks.Query();
		//	                    query.outFields = ["*"];
		//	                    query.where = "objectid > -1";
		//	                    query.returnDistinctValues = true;
		//	                    query.returnGeometry = false;
		//	                    query.num = 1;
		//	                    queryTask.execute(query, function (result) {
		//	                        var fields = [];
		//	                        if (result.fields) {
		//	                            angular.forEach(result.fields, function (value, key) {
		//	                                fields.push({
		//	                                    name: value.alias,
		//	                                    value: value.name,
		//	                                    type: value.type
		//	                                });
		//	                            });
		//	                            locate.queryfields = fields.sort(function (a, b) {
		//	                                return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)
		//	                            });
		//
		//	                            locate.querySearchFields = [];
		//	                            locate.querySearchFields.push({
		//	                                name: locate.queryfields[0].name,
		//	                                content: ""
		//	                            });
		//	                        }
		//	                    }, function (error) {
		//	                        locate.valid = false;
		//	                    });
		//	                });
	}

	private processMeasureToGeometry(locate: LocateUnit): any {
		//		if (locate.preloadData) {
		//			                esriLoader.loadModules([
		//								"esri/tasks/QueryTask", 
		//								"esri/tasks/query", 
		//								"esri/geometry/SpatialReference"
		//							], srsApp.CONFIG.version.arcgisVersion).then(function ([
		//								QueryTask, 
		//								Query, 
		//								SpatialReference
		//							]) {
		//		                        queryTask = new esri.tasks.QueryTask(locate.preloadData.url);
		//		                        query = new esri.tasks.Query();
		//		                        query.outFields = ["ROUTE_NAME", "START_ACCUM", "END_ACCUM", "ROUTE_DIR", "FULL_ROUTE_NAME"];
		//		                        var dirty = (new Date()).getTime();
		//		                        query.where = "objectid > -1 AND ROUTE_TYPE = 'M' AND " + dirty + "=" + dirty;
		//		                        query.returnGeometry = false;
		//		                        query.outSpatialReference = new SpatialReference(configService.getConfig().esri.spatialReference);
		//		                        query.orderByFields = ["ROUTE_NAME"];
		//		                        query.groupByFieldsForStatistics = ["ROUTE_NAME", "ROUTE_DIR"];
		//		                        queryTask.execute(query, function (result) {
		//		                            var features = [];
		//		                            if (result.features) {
		//		                                angular.forEach(result.features, function (value, key) {
		//		                                    features.push({
		//		                                        attributes: value.attributes,
		//		                                    })
		//		                                });
		//		                                locate.queryFeatures = features;
		//		                            }
		//		                        },  function (error) {
		//		                            locate.valid = false;
		//		                        });
		//		                    });
		//		            }
	}

	async findDynamic(url: any, querySearchFields: any, queryfields: any, resultFields: any): Promise<any> {
		//		var rv_deferred = $q.defer();
		//		            esriLoader.loadModules([
		//						"esri/tasks/QueryTask", 
		//						"esri/tasks/query", 
		//						"esri/geometry/SpatialReference"
		//					], srsApp.CONFIG.version.arcgisVersion).then( function ([
		//						QueryTask, 
		//						Query, 
		//						SpatialReference
		//					]) {
		//		                   queryTask = new esri.tasks.QueryTask(url);
		//
		//		                   //initialize query;
		//		                   query = new esri.tasks.Query();
		//		                   var queryStr = [];
		//		                   for (var i = 0; i < queryfields.length; i++) {
		//		                       var field = fields.filter(function (x) { if (x.value == queryfields[i].name) { return x } })[0]
		//		                       if (field.type == "esriFieldTypeString") {
		//		                           queryStr.push("{0} like '%{1}%'".format(field.value, queryfields[i].content));
		//		                       } else {
		//		                           queryStr.push("{0} = {1}".format(field.value, queryfields[i].content));
		//		                       }
		//		                   };
		//
		//		                   query.outFields = ["*"];
		//		                   query.where = queryStr.join(" AND ");
		//		                   query.returnDistinctValues = false;
		//		                   query.returnGeometry = true;
		//		                   query.outSpatialReference = new SpatialReference(4326);
		//		                   //execute query;
		//		                   queryTask.execute(query, function (result) {
		//		                       var mileposts = [];
		//		                       for (var i = 0; i < result.features.length; i++) {
		//		                           var currFeature = result.features[i];
		//		                           var name = "";
		//		                           for (var j = 0; j < returnFields.length; j++) {
		//		                               name += returnFields[j] + ":" + currFeature.attributes[returnFields[j]] + " "
		//		                           };
		//		                           var geo = currFeature.geometry;
		//		                           if (name != null && name.trim() != "") {
		//		                               mileposts.push({
		//		                                   name: name,
		//		                                   geometry: geo,
		//		                                   attributes: currFeature.attributes
		//		                               });
		//		                           };
		//		                       };
		//		                       rv_deferred.resolve(mileposts);
		//		                   }
		//
		//		                       ,
		//		                       function (error) {
		//		                           rv_deferred.reject([]);
		//		                       }
		//		                   );
		//		               });
		//		           return rv_deferred.promise;
	}

	async findImage(url: any, filename: any, start: any, end: any, created_user: string): Promise<any> {
		//		var rv_deferred = $q.defer();
		//		           esriLoader.loadModules([
		//					"esri/tasks/QueryTask", 
		//					"esri/tasks/query", 
		//					"esri/geometry/SpatialReference"
		//				], srsApp.CONFIG.version.arcgisVersion).then( function ([
		//					QueryTask, 
		//					Query, 
		//					SpatialReference
		//				]) {
		//		               queryTask = new esri.tasks.QueryTask(url);
		//
		//		               //initialize query;
		//		               query = new esri.tasks.Query();
		//		               var queryStr = "";
		//		               if (filename) {
		//		                   queryStr += (queryStr == "" ? "image_filename LIKE '%{0}%'".format(filename) : " image_filename LIKE '%{0}%'".format(filename))
		//		               }
		//		               if (created_user) {
		//		                   queryStr += (queryStr == "" ? "created_user = '{0}'".format(created_user) : " AND created_user = '{0}'".format(created_user))
		//		               }
		//		               if (startString && endString) {
		//		                   queryStr += (queryStr == "" ? "created_date BETWEEN date '{0}' AND date '{1}'".format(startString, endString) : " AND created_date BETWEEN date '{0}' AND date '{1}'".format(startString, endString))
		//		               }
		//
		//		               query.outFields = ["image_filename"];
		//		               query.where = queryStr;
		//		               query.returnDistinctValues = false;
		//		               query.returnGeometry = true;
		//		               query.outSpatialReference = new SpatialReference(4326);
		//		               //execute query;
		//		               queryTask.execute(query, function (result) {
		//		                   var images = [];
		//		                   for (var i = 0; i < result.features.length; i++) {
		//		                       var currFeature = result.features[i];
		//		                       var name = currFeature.attributes["image_filename"];
		//		                       var geo = currFeature.geometry;
		//		                       if (name != null && name.trim() != "") {
		//		                           images.push({
		//		                               name: name,
		//		                               geometry: geo
		//		                           });
		//		                       };
		//		                   };
		//		                   rv_deferred.resolve(images);
		//		               }
		//
		//		                   ,
		//		                   function (error) {
		//		                       rv_deferred.reject([]);
		//		                   }
		//		               );
		//		           });
		//		       return rv_deferred.promise;
	}

	//	findAddressByLocator = function(url, street, zipcode, isStreet, callback) {
	//				        // SRS custom search by address
	//		                // check street, add "CA" if needed
	//						
	//						const params = {
	//		                    f: "json", // Response format
	//		                    SingleLine: street+",CA", // Input address
	//		                    outFields: "Match_addr,Addr_type", // Fields to return
	//		                    maxLocations: 5 // Maximum results
	//		                };
	//						$.ajax({
	//							url: url,
	//							data: params,
	//							type: "GET",
	//							beforeSend: function (xhr) {
	//								// Remove X-XSRF-TOKEN header if it exists
	//								//xhr.setRequestHeader("X-XSRF-TOKEN", null);
	//							},
	//							success: callback,
	//							error: function (xhr, status, error) {
	//								console.error("Error:", error);
	//							}
	//						});
	//		    }

	//findAddressByLocator1 = function (url, street, city, state, zipcode, singleLine, callback) {
	//			// for GeocodeServer
	//            esriLoader.loadModules([
	//				"esri/tasks/locator",
	//				"esri/geometry/SpatialReference"
	//			], srsApp.CONFIG.version.arcgisVersion).then( 
	//				function ([Locator, SpatialReference]) {
	//                    var locator = new Locator(url);
	//                    var addresses = null;
	//                    locator.outSpatialReference = new SpatialReference(configService.getConfig().esri.spatialReference);
	//
	//                    if (!singleLine) {
	//                        addresses = [{
	//                            "OBJECTID": 0,
	//                            "STREET": street,
	//                            "ZONE": zipcode
	//                        }];
	//
	//                        var options = {
	//                            addresses: addresses
	//                        };
	//
	//                        locator.addressesToLocations(options, callback);
	//                    } else {
	//                        addresses = {};
	//                        street ? addresses.address = street : ""
	//                        city ? addresses.city = city : ""
	//                        state ? addresses.region = state : ""
	//                        zipcode ? addresses.postal = zipcode : ""
	//
	//                        var options = {
	//                            address: addresses
	//                        };
	//
	//                        locator.addressToLocations(options, callback);
	//                    };
	//                });
	//        }

	//processGeometryList = function (locate) {
	//	            esriLoader.loadModules([
	//					"esri/tasks/QueryTask", 
	//					"esri/tasks/query", 
	//					"esri/geometry/SpatialReference"
	//				], srsApp.CONFIG.version.arcgisVersion).then( function ([
	//					QueryTask, 
	//					Query, 
	//					SpatialReference
	//				]) {
	//                    var queryTask = new esri.tasks.QueryTask(locate.url);
	//                    var query = new esri.tasks.Query();
	//                    query.returnGeometry = true;
	//                    query.outFields = locate.outfields;
	//                    query.where = locate.where;
	//                    query.outSpatialReference = new SpatialReference(configService.getConfig().esri.spatialReference);
	//                    queryTask.execute(query, function (result) {
	//                        locate.geometryList = [];
	//                        var geometryTrack = {};
	//                        for (var i = 0; i < result.features.length; i++) {
	//                            var currFeature = result.features[i];
	//                            var text = currFeature.attributes[locate.text];
	//                            if (!geometryTrack[text]) {
	//                                geometryTrack[text] = 1;
	//
	//                                locate.geometryList.push({
	//                                    "name": text,
	//                                    geometry: currFeature.geometry
	//                                });
	//                            } else {
	//                                locate.geometryList.push({
	//                                    "name": text + " " + ++geometryTrack[text],
	//                                    geometry: currFeature.geometry
	//                                });
	//                            }
	//                        }
	//                    }, function (error) {
	//                        locate.valid = false;
	//                    });
	//                });
	//        }

	//processSection = function (locate) {
	//	            esriLoader.loadModules([
	//					"esri/tasks/QueryTask", 
	//					"esri/tasks/query", 
	//					"esri/geometry/SpatialReference"
	//				], srsApp.CONFIG.version.arcgisVersion).then( function ([
	//					QueryTask, 
	//					Query, 
	//					SpatialReference
	//				]) {
	//                    queryTask = new esri.tasks.QueryTask(locate.url);
	//                    var township = locate.selectedTownship.name;
	//                    var range = locate.selectedRange.name;
	//                    query = new esri.tasks.Query();
	//                    query.returnGeometry = true;
	//                    query.outFields = [locate.sectionField];
	//                    query.where = locate.townshipField + " = \'" + township + "\' AND " + locate.rangeField + " = \'" + range + "\'";
	//                    query.outSpatialReference = new SpatialReference(configService.getConfig().esri.spatialReference);
	//                    queryTask.execute(query, function (result) {
	//                        locate.selectedRange.sections = [];
	//                        var sections = [];
	//                        for (var i = 0; i < result.features.length; i++) {
	//                            var currFeature = result.features[i];
	//                            var sectionName = currFeature.attributes[locate.sectionField];
	//                            sections.push({
	//                                "name": sectionName,
	//                                geometry: currFeature.geometry
	//                            });
	//                        }
	//                        locate.selectedRange.sections = sections.sort(function (a, b) {
	//                            return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)
	//                        });
	//                        $timeout(function () {
	//                            locate.selectedSection = locate.selectedRange.sections[0]
	//                        }, 500);
	//                    }, function (error) {
	//                        locate.valid = false;
	//                    });
	//                });
	//        }

	//getMeasureToGeometry = function (locate) {
	//            var rv_deferred = $q.defer();
	//            $http({
	//                url: locate.url + '?' + locate.urlParam,
	//                method: "GET",
	//                headers: {
	//                    'Content-Type': undefined,
	//                    'X-XSRF-TOKEN': undefined,
	//                    'X-Requested-With': undefined
	//                }
	//            }).then(
	//                function (response) {
	//                    rv_deferred.resolve(response.data);
	//                }, function (error) {
	//                    rv_deferred.reject(false);
	//                });
	//            return rv_deferred.promise;
	//        }

	//		processArcgis2KV = function (locate) {
	//            var rv_deferred = $q.defer();
	//	            esriLoader.loadModules([
	//					"esri/tasks/QueryTask", 
	//					"esri/tasks/query", 
	//					"esri/geometry/SpatialReference"
	//				], srsApp.CONFIG.version.arcgisVersion).then( function ([
	//					QueryTask, 
	//					Query, 
	//					SpatialReference
	//				]) {
	//                queryTask = new esri.tasks.QueryTask(locate.url);
	//                var dirty = (new Date()).getTime();
	//
	//                query = new esri.tasks.Query();
	//                query.outFields = [locate.resultField.name];
	//                query.orderByFields = [locate.resultField.name];
	//                query.returnGeometry = false;
	//                query.where = "objectid > -1 AND " + dirty + "=" + dirty;
	//                query.geometry = locate.drawing.geometry;
	//                query.returnDistinctValues = true;
	//                query.spatialRelationship = locate.drawing.spatialRelationship;
	//                query.outSpatialReference = new SpatialReference(configService.getConfig().esri.spatialReference);
	//                queryTask.execute(query, function (result) {
	//                    var features = [];
	//                    if (result.features && result.features.length > 0) {
	//                        for (var i = 0; i < 50 && i < result.features.length; i++) {
	//                            features.push({
	//                                value: result.features[i].attributes[locate.resultField.name],
	//                                selected: false
	//                            });
	//                        }
	//                    }
	//                    locate.drawing.results = features;
	//                    rv_deferred.resolve(true);
	//                }, function () {
	//                    locate.valid = false;
	//                    rv_deferred.reject(false);
	//                })
	//            });
	//            return rv_deferred.promise;
	//        }
}
